const GlobalUrl = "https://sciative.com"
const GlobalImg = "https://sciative.com/static/media/sciative-logo.b0efc731650efc86f4f7.webp"
  
const adminURL = '4785';

export { GlobalUrl, GlobalImg, adminURL };